import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "align-center-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 3C3.58579 3 3.25 3.37219 3.25 3.8313C3.25 4.29042 3.58579 4.66261 4 4.66261H20C20.4142 4.66261 20.75 4.29042 20.75 3.8313C20.75 3.37219 20.4142 3 20 3H4Z" }, null, -1),
    _createElementVNode("path", { d: "M6 8.54202C5.58579 8.54202 5.25 8.9142 5.25 9.37332C5.25 9.83244 5.58579 10.2046 6 10.2046H18C18.4142 10.2046 18.75 9.83244 18.75 9.37332C18.75 8.9142 18.4142 8.54202 18 8.54202H6Z" }, null, -1),
    _createElementVNode("path", { d: "M3.25 14.9153C3.25 14.4562 3.58579 14.084 4 14.084H20C20.4142 14.084 20.75 14.4562 20.75 14.9153C20.75 15.3745 20.4142 15.7466 20 15.7466H4C3.58579 15.7466 3.25 15.3745 3.25 14.9153Z" }, null, -1),
    _createElementVNode("path", { d: "M8 19.6261C7.58579 19.6261 7.25 19.9982 7.25 20.4574C7.25 20.9165 7.58579 21.2887 8 21.2887H16C16.4142 21.2887 16.75 20.9165 16.75 20.4574C16.75 19.9982 16.4142 19.6261 16 19.6261H8Z" }, null, -1)
  ])))
}
export default { render: render }